import { PostUploadBudgets } from 'domain/usecases/budgets/upload-budgets';

import { BaseHttpService } from 'main/factories/http';

export class RemotePostUploadBudgets extends BaseHttpService<PostUploadBudgets.Model> implements PostUploadBudgets {
  async postUploadBudgets(body: PostUploadBudgets.Params): Promise<PostUploadBudgets.Model> {
    return await this.request('post', body);
  }
}
